import RandomPlanet from "./RandomPlanet";

export default RandomPlanet;